/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_AccountInputs */

const en_no_account = /** @type {(inputs: No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't have an account yet?`)
};

const nl_no_account = /** @type {(inputs: No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heeft u nog geen account?`)
};

/**
* | output |
* | --- |
* | "Don't have an account yet?" |
*
* @param {No_AccountInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const no_account = /** @type {((inputs?: No_AccountInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_AccountInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_no_account(inputs)
	return en_no_account(inputs)
});